import { Button } from '@mui/material';
import React from 'react';
import { ButtonBaseProps } from './button.types';

enum VariantValue {
  primary = 'contained',
  secondary = 'outlined',
  discreet = 'text',
  gradient = 'contained',
}
type VaritantValueType = keyof typeof VariantValue;
type Props = ButtonBaseProps & {
  variant: VaritantValueType;
};

function ButtonBase({
  variant,
  fullWidth,
  iconRight,
  iconLeft,
  children,
  width,
  id,
  className,
  gap = '7px',
  ...rest
}: Props) {
  const muiVariant = VariantValue[variant];
  const uiClassSuffix = variant === 'gradient' ? 'gradient' : muiVariant;
  return (
    <Button
      disableElevation
      variant={muiVariant}
      sx={{
        width: fullWidth ? '100%' : width || 'auto',
        gap: gap,
      }}
      startIcon={iconLeft}
      endIcon={iconRight}
      {...rest}
      className={className || 'ui-button-' + uiClassSuffix}
      id={id || 'ui-button-' + uiClassSuffix}
    >
      {children}
    </Button>
  );
}

export default ButtonBase;
